import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {
    frotasStorage, aeronavesRoute, embarcacoesRoute, equipamentosRoute,
    veiculosRoute, outrosRoute, maquinarioRoute
} from "../shared/data.service";
import { Frota } from "../shared/frota.model";
import { FrotaNavigationService } from "../shared/frota-navigation.service";
import { FrotaApiService } from "../shared/frota-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { editRoute, newRoute, newRouteFemale } from "../../../shared/services/data.service";
import { FrotasService } from "../shared/frota.service";
import { CorApiService } from "../../cores/cor-api.service";
import { CombustivelApiService } from "../../../abastecimentos/combustiveis/shared/combustivel-api.service";
import { Cor } from "../../cores/cor.model";
import { Combustivel } from "../../../abastecimentos/combustiveis/shared/combustivel.model";
import { Localidade } from "../../../estruturas/localidades/shared/localidade.model";
import { Divisao } from "../../../estruturas/divisoes/shared/divisao.model";
import { Area } from "../../../estruturas/areas/shared/area.model";
import { Orgao } from "../../../estruturas/orgaos/shared/orgao.model";
import { Modelo } from "../../modelos/shared/modelo.model";
import { Setor } from "../../../estruturas/setores/shared/setor.model";
import { OrgaoApiService } from "../../../estruturas/orgaos/shared/orgao-api.service";
import { AreaApiService } from "../../../estruturas/areas/shared/area-api.service";
import { DivisaoApiService } from "../../../estruturas/divisoes/shared/divisao-api.service";
import { SetorApiService } from "../../../estruturas/setores/shared/setor-api.service";
import { LocalidadeApiService } from "../../../estruturas/localidades/shared/localidade-api.service";
import { ModeloApiService } from "../../modelos/shared/modelo-api.service";
import { orgaosStorage, orgaosQuery } from "../../../estruturas/orgaos/shared/data.service";
import { OrgaoNavigationService } from "../../../estruturas/orgaos/shared/orgao-navigation.service";
import { AreaNavigationService } from "../../../estruturas/areas/shared/area-navigation.service";
import { DivisaoNavigationService } from "../../../estruturas/divisoes/shared/divisao-navigation.service";
import { SetorNavigationService } from "../../../estruturas/setores/shared/setor-navigation.service";
import { LocalidadeNavigationService } from "../../../estruturas/localidades/shared/localidade-navigation.service";
import { ModeloNavigationService } from "../../modelos/shared/modelo-navigation.service";
import { areasStorage, areasQuery } from "../../../estruturas/areas/shared/data.service";
import { divisoesStorage, divisoesQuery } from "../../../estruturas/divisoes/shared/data.service";
import { setoresStorage, setoresQuery } from "../../../estruturas/setores/shared/data.service";
import { localidadesStorage, localidadesQuery } from "../../../estruturas/localidades/shared/data.service";
import { modelosStorage, modelosQueryComCategoriaMarca } from "../../modelos/shared/data.service";
import { BemCombustivelApiService } from "../../bem-combustiveis/bem-combustivel-api.service";
import { ModeloService } from "../../modelos/shared/modelo.service";
import { Marca } from "../../marcas/shared/marca.model";
import { MarcaApiService } from "../../marcas/shared/marca-api.service";
import { MarcaNavigationService } from "../../marcas/shared/marca-navigation.service";
import { marcasStorage, marcasQuery } from "../../marcas/shared/data.service";
import { LocalidadeService } from "../../../estruturas/localidades/shared/localidade.service";
import { Situacao } from "../../situacoes/situacao.model";
import { SituacaoApiService } from "../../situacoes/situacao-api.service";
import { Motorista } from "../../../recursos-humanos/motoristas/shared/motorista.model";
import { MotoristaApiService } from "../../../recursos-humanos/motoristas/shared/motorista-api.service";
import { MotoristaService } from "../../../recursos-humanos/motoristas/shared/motorista.service";
import { months } from "../../../abastecimentos/abastecimento-bens/shared/data.service";
import { coresQuery } from "../../cores/data.service";
import { motoristasQuery } from "../../../recursos-humanos/motoristas/shared/data.service";
import { CategoriaCnh } from "../../cnh/categorias-cnh/shared/categoria-cnh.model";
import { CategoriaCnhApiService } from "../../cnh/categorias-cnh/shared/categoria-cnh-api.service";
import { FormaControleApiService } from "../../formas-controle/shared/forma-controle-api.service";
import { FormaControle } from "../../formas-controle/shared/forma-controle.model";
import { FormaControleService } from "../../formas-controle/shared/forma-controle.service";
import {LicenciamentoApiService} from "../../../despachos/licenciamentos/shared/licenciamento-api.service";
import {ProjetoService} from "../../../projeto/shared/projeto.service";
import {ModeloGpsService} from "../../../rastreamentos/modelos-gps/shared/modelo-gps.service";
import {ModeloGpsApiService} from "../../../rastreamentos/modelos-gps/shared/modelo-gps-api.service";
import {modeloGpsQuery} from "../../../rastreamentos/modelos-gps/shared/data.service";

@Component({
    template: require('./frota-form.component.html'),
    styles: [require('./frota-form.component.css')]
})
export class FrotaFormComponent implements OnInit {
    frotasModule:any = {};
    formObject:any = new Frota();
    corObject:Cor = new Cor();
    modeloObject:any = new Modelo();
    marcaObject:any = new Marca();
    orgaoObject:Orgao = new Orgao();
    areaObject:Area = new Area();
    divisaoObject:Divisao = new Divisao();
    setorObject:Setor = new Setor();
    localidadeObject:Localidade = new Localidade();
    situacaoObject:Situacao = new Situacao();
    motoristaObject:any = new Motorista();
    categoriaCnhObject:any = new CategoriaCnh();
    formaControleObject:any = new FormaControle();
    modeloGpsObject: any = {};
    actionTitle:string;
    articleTitle:string;
    submitted:boolean = false;
    btnSaveDisabled:boolean = false;
    showDetailLink:boolean = false;
    identificationText:string;

    situacoesList:Combustivel[] = [];
    combustiveisList:Combustivel[] = [];
    combustiveisCheckedList:number[] = [];
    modeloSelectId:string = 'modelo';
    modeloDisabled: boolean = true;
    marcaSelectId:string = 'marca';
    marcaQuery:any = marcasQuery;
    modeloQuery: any = this._utilService.cloneObject(modelosQueryComCategoriaMarca);
    orgaoSelectId:string = 'orgao';
    orgaoQuery: any = orgaosQuery;
    areaSelectId:string = 'area';
    areaQuery: any = this._utilService.cloneObject(areasQuery);
    divisaoSelectId:string = 'divisao';
    divisaoQuery: any = this._utilService.cloneObject(divisoesQuery);
    setorSelectId:string = 'setor';
    setorQuery: any = this._utilService.cloneObject(setoresQuery);
    localidadeQuery: any = this._utilService.cloneObject(localidadesQuery);
    localidadeSelectId:string = 'localidade';
    corSelectId: string = "cor";
    corQuery: any = this._utilService.cloneObject(coresQuery);
    corLoading: boolean = false;
    motoristaSelectId: string = 'motorista';
    motoristaQuery: any = this._utilService.cloneObject(motoristasQuery);
    monthsList: any[] = [];
    formasControleList: any[] = [];
    categoriasCnhList: any[] = [];
    showTipoOdometro: boolean = true;
    modeloGpsSelectId: string = 'modeloGps';
    modeloGpsQuery: any;
    loadingMesLicenciamento: boolean = false;

    form:FormGroup;
    ativo = new FormControl('');
    capacidadeCarga = new FormControl('');
    categoriaCnh = new FormControl('');
    dataCompra = new FormControl('');
    dataTerminoGarantia = new FormControl('');
    dataVenda = new FormControl('');
    descricao = new FormControl('');
    identificacao = new FormControl('', Validators.required);
    anoModelo = new FormControl('');
    chassi = new FormControl('');
    codigo = new FormControl('', Validators.required);
    codigoPatrimonio = new FormControl('', Validators.required);
    numeroPassageiros = new FormControl('');
    numeroRenavam = new FormControl('');
    placa = new FormControl('');
    terceiro = new FormControl('');
    modelo = new FormControl('', Validators.required);
    orgao = new FormControl('');
    area = new FormControl('');
    divisao = new FormControl('');
    setor = new FormControl('');
    localidade = new FormControl('');
    cor = new FormControl('');
    anoFabricacao = new FormControl('');
    numeroSerie = new FormControl('');
    marca = new FormControl('', Validators.required);
    situacao = new FormControl('');
    motorista = new FormControl('');
    mesLicenciamento = new FormControl('');
    mesSeguroObrigatorio = new FormControl('');
    mesIPVA = new FormControl('');
    formaControle = new FormControl('');
    gpsImei = new FormControl('');
    gpsTelefone = new FormControl('');
    modeloGps = new FormControl('');
    velocidadeMaximaPermitida = new FormControl('');

    thisRoute:string = '';
    aeronavesRoute:string = aeronavesRoute;
    embarcacoesRoute:string = embarcacoesRoute;
    equipamentosRoute:string = equipamentosRoute;
    maquinarioRoute:string = maquinarioRoute;
    outrosRoute:string = outrosRoute;
    veiculosRoute:string = veiculosRoute;

    private returnToOtherForm:boolean = false;
    private otherForm:string;
    private responseFrota:any;
    private moduleId:number;
    private project: any;

    constructor(
        private _route:ActivatedRoute,
        private _router: Router,
        private _frotaNavigationService:FrotaNavigationService,
        private _frotaApiService:FrotaApiService,
        private _frotasService:FrotasService,
        private _utilService:UtilService,
        private _autocompleteService:AutoCompleteService,
        private _corApiService:CorApiService,
        private _combustivelApiService:CombustivelApiService,
        private _bemCombustivelApiService:BemCombustivelApiService,
        private _orgaoApiService:OrgaoApiService,
        private _orgaosNavigationService:OrgaoNavigationService,
        private _areaApiService:AreaApiService,
        private _areaNavigationService:AreaNavigationService,
        private _divisaoApiService:DivisaoApiService,
        private _divisaoNavigationService:DivisaoNavigationService,
        private _setorApiService:SetorApiService,
        private _setorNavigationService:SetorNavigationService,
        private _localidadeApiService:LocalidadeApiService,
        private _localidadeNavigationService:LocalidadeNavigationService,
        private _localidadeService:LocalidadeService,
        private _modeloApiService:ModeloApiService,
        private _modeloNavigationService:ModeloNavigationService,
        private _modeloService:ModeloService,
        private _marcaApiService:MarcaApiService,
        private _marcaNavigationService:MarcaNavigationService,
        private _situacaoApiService: SituacaoApiService,
        private _motoristaApiService: MotoristaApiService,
        private _motoristaService: MotoristaService,
        private _categoriaCnhApiService: CategoriaCnhApiService,
        private _formaControleApiService: FormaControleApiService,
        private _modeloGpsService: ModeloGpsService,
        private _modeloGpsApiService: ModeloGpsApiService,
        private _licenciamentoApiService: LicenciamentoApiService,
        private _projetoService: ProjetoService,
        private _formaControleService: FormaControleService,
        private _fb:FormBuilder) {
        this.form = _fb.group({
            ativo: this.ativo,
            capacidadeCarga: this.capacidadeCarga,
            categoriaCnh: this.categoriaCnh,
            dataCompra: this.dataCompra,
            dataTerminoGarantia: this.dataTerminoGarantia,
            dataVenda: this.dataVenda,
            descricao: this.descricao,
            identificacao: this.identificacao,
            anoModelo: this.anoModelo,
            chassi: this.chassi,
            codigo: this.codigo,
            codigoPatrimonio: this.codigoPatrimonio,
            numeroPassageiros: this.numeroPassageiros,
            numeroRenavam: this.numeroRenavam,
            placa: this.placa,
            terceiro: this.terceiro,
            modelo: this.modelo,
            orgao: this.orgao,
            area: this.area,
            divisao: this.divisao,
            setor: this.setor,
            localidade: this.localidade,
            cor: this.cor,
            anoFabricacao: this.anoFabricacao,
            marca: this.marca,
            numeroSerie: this.numeroSerie,
            situacao: this.situacao,
            motorista: this.motorista,
            mesLicenciamento: this.mesLicenciamento,
            mesSeguroObrigatorio: this.mesSeguroObrigatorio,
            mesIPVA: this.mesIPVA,
            formaControle: this.formaControle,
            gpsImei: this.gpsImei,
            gpsTelefone: this.gpsTelefone,
            modeloGps: this.modeloGps,
            velocidadeMaximaPermitida: this.velocidadeMaximaPermitida
        });
    }

    ngOnInit() {
        this.getSituacoes();
        this.getCombustiveis();
        this.getCategoriasCnh();
        this.getFormasControle();

        this.project = this._projetoService.getSessionStorage();
        this.monthsList = this._utilService.cloneObject(months);
        this.monthsList.unshift({Key: null, Value: '— Selecione —'});

        const history = this._frotasService.getBackStorage();
        if ((history)) {
            this.showDetailLink = true;
        }

        this.frotasModule = this._frotasService.getModuleName();
        this.thisRoute = this._frotasService.getRouteName();
        this.moduleId = this._frotasService.getModuleId();

        this.modeloGpsQuery = this._utilService.cloneObject(modeloGpsQuery);
        this.setCategoriaOnModelo();

        this.testSession();
    }

    clickGoToList() {
        this.goToList();
    }

    clickGoToDetail() {
        this._frotaNavigationService.goToDetail(this.formObject.id, this.thisRoute);
    }

    clickCancel() {
        this.toLeaveHere();
    }

    clickCheckCombustiveis(item:Combustivel) {
        var x: any, lenX: any,
            add:boolean = true;

        for (x = 0, lenX = this.combustiveisCheckedList.length; x < lenX; x++) {
            if (this.combustiveisCheckedList[x] === item.id) {
                this.combustiveisCheckedList.splice(x, 1);
                add = false;
                break;
            }
        }

        if (add) {
            this.combustiveisCheckedList.push(item.id);
        }
    }

    clickThird() {
        if (this.formObject.terceiro) {
            this.onShowPatrimonio();
        } else {
            this.onHidePatrimonio();
        }
    }

    clickCheckSituacao(item: any) {
        this.situacaoObject = item;
    }

    changeFormaControle() {
        let formaControleId: number;
        if (this.formaControleObject && this.formaControleObject.id) {
            formaControleId = this.formaControleObject.id;
            this.showTipoOdometro = this._formaControleService.changeFormaControle(formaControleId);
        }

        // if (this.formaControleObject && this.formaControleObject.id) {
        //     formaControleId = this.formaControleObject.id;
        //
        //     let tipoOdometro: any = this._formaControleService.changeFormaControle(formaControleId);
        //
        //     if (tipoOdometro === null) {
        //         this.formObject.odometroHorimetroValue = null;
        //     }
        //
        //     if (tipoOdometro) {
        //         this.showTipoOdometro = true;
        //     } else {
        //         this.showTipoOdometro = false;
        //     }
        // }
    }

    blurPlaca() {
        if (this.formObject.placa) {
            let p: string = this.formObject.placa;
            p = p.replace(/\D/g, '');

            let last:  number = p.length;

            if (last === 4) {
                let lastPlacaNumber: any = p.charAt(last - 1);
                if (this.project) {
                    this.getMesLicenciamento(lastPlacaNumber);
                }
            }

        }
    }

    onSubmit(evt: any) {
        this.submitted = true;

        if (this.formObject.terceiro) {
            this._utilService.setSelectOnFormControl(this.form, 'codigoPatrimonio', {id: -1});
        }

        if (evt.valid) {
            this.btnSaveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject),
                date:any;

            if (this.modeloObject.id) {
                object.modeloId = this.modeloObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.orgaoObject.id) {
                object.orgaoId = this.orgaoObject.id;
            } else {
                object.orgaoId = null;
            }

            if (this.areaObject.id) {
                object.areaId = this.areaObject.id;
            } else {
                object.areaId = null;
            }

            if (this.divisaoObject.id) {
                object.divisaoId = this.divisaoObject.id;
            } else {
                object.divisaoId = null;
            }

            if (this.setorObject.id) {
                object.setorId = this.setorObject.id;
            } else {
                object.setorId = null;
            }

            if (this.localidadeObject.id) {
                object.localidadeId = this.localidadeObject.id;
            } else {
                object.localidadeId = null;
            }

            if (this.motoristaObject.id) {
                object.motoristaPrincipalId = this.motoristaObject.id;
            } else {
                object.motoristaPrincipalId = null;
            }

            if (this.corObject.id) {
                object.corId = this.corObject.id;
            }

            if (this.situacaoObject.id) {
                object.situacaoId = this.situacaoObject.id;
            }

            if (this.modeloGpsObject.id) {
                object.gpsModeloId = this.modeloGpsObject.id;
            } else {
                object.gpsModeloId = null;
            }

            if (this.formaControleObject.id) {
                object.formaControleId = this.formaControleObject.id;
                object.odometroHorimetro = this._formaControleService.submitOdometroHorimetro(object.odometroHorimetroValue);
                delete object['odometroHorimetroValue'];

                if (!object.dataOdometroHorimetro) {
                    object.dataOdometroHorimetro = new Date();
                }
            }

            if (this.combustiveisCheckedList.length) {
                object.Combustiveis = this.combustiveisCheckedList;
            } else {
                object.Combustiveis = [];
            }

            if (object.mesIPVA) {
                object.mesIPVA = object.mesIPVA.Key;
            } else {
                object.mesIPVA = null;
            }

            if (object.mesLicenciamento) {
                object.mesLicenciamento = object.mesLicenciamento.Key;
            } else {
                object.mesLicenciamento = null;
            }

            if (object.mesSeguroObrigatorio) {
                object.mesSeguroObrigatorio = object.mesSeguroObrigatorio.Key;
            } else {
                object.mesSeguroObrigatorio = null;
            }

            if (object.placa) {
                object.placa = this._utilService.removeSpecialCharacter(object.placa);
            }

            if (object.terceiro) {
                object.codigoPatrimonio = '';
            }

            date = document.getElementById('data_compra');
            if (date.value) {
                object.dataCompra = this._utilService.convertStringToDate(date.value);
            } else {
                object.dataCompra = null;
            }

            date = document.getElementById('termino_garantia');
            if (date.value) {
                object.dataTerminoGarantia = this._utilService.convertStringToDate(date.value);
            } else {
                object.dataTerminoGarantia = null;
            }

            date = document.getElementById('data_venda');
            if (date.value) {
                object.dataVenda = this._utilService.convertStringToDate(date.value);
            } else {
                object.dataVenda = null;
            }

            if (this.categoriaCnhObject.id) {
                object.categoriaExigidaId = this.categoriaCnhObject.id;
            } else{
                object.categoriaExigidaId = null;
            }

            if (this.formObject.id) {
                this.onEditFrota(object);
            } else {
                this.onAddFrota(object);
            }
        }
    }

    getOrgaosObject(object:any) {
        if (object.novo) {
            var thisFormObject:any = this.setObjectBeforeLeave();

            this._frotasService.setSessionStorage(thisFormObject);

            const toOtherFormObject: any = {
                razaoSocial: object.text,
                form: frotasStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, orgaosStorage);
            this._orgaosNavigationService.goToNew();
        } else {
            this.orgaoObject = object;
            if (object.id) {
                this.areaQuery.where.orgaoId = object.id;
                this._utilService.setSelectOnFormControl(this.form, 'orgao', object);
            } else {
                this._utilService.setSelectOnFormControl(this.form, 'orgao', {id: -1});
            }
        }
    }

    getAreasObject(object:any) {
        if (object.novo) {
            var thisFormObject:any = this.setObjectBeforeLeave();

            this._frotasService.setSessionStorage(thisFormObject);

            var toOtherFormObject:any = {
                nome: object.text,
                form: frotasStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, areasStorage);
            this._areaNavigationService.goToNew();
        } else {
            this.areaObject = object;
            if (object.id) {
                this.divisaoQuery.where.areaId = object.id;
                this._utilService.setSelectOnFormControl(this.form, 'area', object);
            } else {
                this._utilService.setSelectOnFormControl(this.form, 'area', {id: -1});
            }
        }
    }

    getDivisoesObject(object:any) {
        if (object.novo) {
            var thisFormObject:any = this.setObjectBeforeLeave();

            this._frotasService.setSessionStorage(thisFormObject);

            var toOtherFormObject:any = {
                divisao: object.text,
                form: frotasStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, divisoesStorage);
            this._divisaoNavigationService.goToNew();
        } else {
            this.divisaoObject = object;
            if (object.id) {
                this.setorQuery.where.divisaoId = object.id;
                this._utilService.setSelectOnFormControl(this.form, 'divisao', object);
            } else {
                this._utilService.setSelectOnFormControl(this.form, 'divisao', {id: -1});
            }
        }
    }

    getSetoresObject(object:any) {
        if (object.novo) {
            var thisFormObject:any = this.setObjectBeforeLeave();

            this._frotasService.setSessionStorage(thisFormObject);

            var toOtherFormObject:any = {
                setor: object.text,
                form: frotasStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, setoresStorage);
            this._setorNavigationService.goToNew();
        } else {
            this.setorObject = object;
            if (object.id) {
                this._utilService.setSelectOnFormControl(this.form, 'setor', object);
            } else {
                this._utilService.setSelectOnFormControl(this.form, 'setor',{id: -1});
            }
        }
    }

    getLocalidadesObject(object:any) {
        if (object.novo) {
            var thisFormObject:any = this.setObjectBeforeLeave();

            this._frotasService.setSessionStorage(thisFormObject);

            var toOtherFormObject:any = {
                localidade: object.text,
                form: frotasStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, localidadesStorage);
            this._localidadeNavigationService.goToNew();
        } else {
            this.localidadeObject = object;
            if (object.id) {
                this._utilService.setSelectOnFormControl(this.form, 'localidade', object);
            } else {
                this._utilService.setSelectOnFormControl(this.form, 'localidade', {id: -1});
            }
        }
    }

    getModelosObject(object:any) {
        if (object.novo) {
            var thisFormObject:any = this.setObjectBeforeLeave();

            this._frotasService.setSessionStorage(thisFormObject);

            var toOtherFormObject:any = {
                modelo: object.text,
                categoriaId: this.moduleId,
                marca: this.marcaObject,
                form: frotasStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, modelosStorage);
            this._modeloNavigationService.goToNew();
        } else {
            this.modeloObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'modelo', object);
        }
    }

    getMarcasObject(object: any) {
        if(object.novo) {
            var thisFormObject: any = this.setObjectBeforeLeave();

            this._frotasService.setSessionStorage(thisFormObject);

            var toOtherFormObject: any = {
                marca: object.text,
                form: frotasStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, marcasStorage);
            this._marcaNavigationService.goToNew();
        } else {
            this.marcaObject = object;
            this.setMarcaOnModelo();
            this._utilService.setSelectOnFormControl(this.form, 'marca', object);
        }
    }

    getCorObject(object: any) {
        var onDone = function(Response: any) {
            if (!Response.error)  {
                onSet(Response);
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this);

        var onSet = function(obj: any) {
            this.corObject = obj;
            this.setCorAutoComplete();
            this.corLoading = false;
        }.bind(this);

        if(object.novo) {
            this.corLoading = true;
            var newObj: Cor = new Cor();
            newObj.cor = object.text;
            this._corApiService.onPost(newObj, onDone);
        } else {
            onSet(object);
        }
    }

    modeloTemplateResult = (function(state: any) {
        var template: any = this._modeloService.templateResult(state, true);
        return template;
    }.bind(this));

    getMotoristaObject(object: any) {
        this.motoristaObject = object;
        if (object.id) {
            this._utilService.setSelectOnFormControl(this.form, 'motorista', object);
        } else {
            this._utilService.setSelectOnFormControl(this.form, 'motorista', {id: -1});
        }
    }

    motoristaTemplateResult = (function(state: any) {
        var template: any = this._motoristaService.templateResult(state, false);
        return template;
    }.bind(this));

    getModeloGpsObject(object: any) {
        this.modeloGpsObject = object;
        if (object.id) {
            this._utilService.setSelectOnFormControl(this.form, 'modeloGps', object);
        } else {
            this._utilService.setSelectOnFormControl(this.form, 'modeloGps', {id: -1});
        }
    }

    modeloGpsTemplateResult = (function(state: any) {
        var template: any = this._modeloGpsService.templateResult(state, false);
        return template;
    }.bind(this));

    private onAddFrota(object:Frota) {
        this._frotaApiService.onPost(object, this.onDone);
    }

    private onEditFrota(object:Frota) {
        this._frotaApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseFrota = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private setObjectBeforeLeave() {
        var object:any = this.formObject;
        object.modelo = this.modeloObject;
        object.modelo.marca = this.marcaObject;
        object.cor = this.corObject;
        object.combustiveis = this.combustiveisCheckedList;
        object.orgao = this.orgaoObject;
        object.area = this.areaObject;
        object.divisao = this.divisaoObject;
        object.setor = this.setorObject;
        object.localidade = this.localidadeObject;
        object.situacao = this.situacaoObject;
        object.motoristaPrincipal = this.motoristaObject;
        object.categoriaExigida = this.categoriaCnhObject;
        object.formaControle = this.formaControleObject;
        object.gpsModelo = this.modeloGpsObject;
        object.thisRoute = this.thisRoute;

        return object;
    }

    private onShowPatrimonio() {
        document.getElementById('from-group_codigoPatrimonio').className = 'geo-input--3c geo-input--error';
        var element:any = document.getElementById('codigoPatrimonio');
        element.disabled = false;
        if (document.getElementById('asterisk_codigoPatrimonio')) {
            document.getElementById('asterisk_codigoPatrimonio').style.visibility = 'visible';
        }
    }

    private onHidePatrimonio() {
        document.getElementById('from-group_codigoPatrimonio').className = 'geo-input--3c';
        var element:any = document.getElementById('codigoPatrimonio');
        element.disabled = true;
        this.formObject.codigoPatrimonio = null;
        if (document.getElementById('asterisk_codigoPatrimonio')) {
            document.getElementById('asterisk_codigoPatrimonio').style.visibility = 'hidden';
        }
    }

    private getCombustiveis() {
        var onDone = (function (Response: any) {
            if (!Response.error)  {
                var x: any, lenX: any;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        this.combustiveisList.push(Response[x]);
                    }
                }
            }
        }.bind(this));

        this._combustivelApiService.onGetAll(onDone);
    }

    private getSituacoes() {
        var onDone = (function (Response: any) {
            if (!Response.error)  {
                this.situacoesList = Response;
                this.setSituacao();
            }
        }.bind(this));

        this._situacaoApiService.onGetAll(onDone);
    }

    private getMesLicenciamento(finalPlaca: number) {
        var onDone = (function (Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number,
                    t: any;

                if (Response.length) {
                    t = Response[0];
                    for (x = 0, lenX = this.monthsList.length; x < lenX; x++) {
                        if (this.monthsList[x].Key === t.mes) {
                            this.formObject.mesLicenciamento = this.monthsList[x];
                            break;
                        }
                    }
                }

                this.loadingMesLicenciamento = false;
            }
        }.bind(this));

        this.loadingMesLicenciamento = true;
        let query: any = {where: {
            estadoId: this.project.estadoId,
            finalPlaca: Number(finalPlaca)
        }};
        this._licenciamentoApiService.onGetFilter(query, onDone);
    }


    private getCombustiveisByBem(bemId: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: any, lenX: any,
                    element: any;

                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    this.combustiveisCheckedList.push(Response[x].combustivelId);
                    element = document.getElementById("check_combustivel_" + Response[x].combustivelId);
                    if (element) {
                        element.checked = true;
                    }
                }
            }
        }.bind(this));

        this._bemCombustivelApiService.onGetByBem(bemId, onDone);
    }

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.identificationText = Response.identificacao;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum ' + this.frotasModule.single + ' encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._frotaApiService.onGetById(id, onDone);
    }

    private testSession() {
        var id: number;
        var session: any = this._frotasService.getSessionStorage();
        this._frotasService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            if (this.thisRoute === aeronavesRoute || this.thisRoute === embarcacoesRoute) {
                this.actionTitle = newRouteFemale;
            } else {
                this.actionTitle = newRoute;
            }
        }

        if (this.thisRoute === aeronavesRoute || this.thisRoute === embarcacoesRoute) {
            this.articleTitle = "da";
        } else {
            this.articleTitle = "do";
        }
    }

    private setEditNormal(id: number) {
        this.formObject.mesIPVA = this.monthsList[0];
        this.formObject.mesLicenciamento = this.monthsList[0];
        this.formObject.mesSeguroObrigatorio = this.monthsList[0];

        this.getObject(id);
        this.getCombustiveisByBem(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
        this.formObject.mesIPVA = this.monthsList[0];
        this.formObject.mesLicenciamento = this.monthsList[0];
        this.formObject.mesSeguroObrigatorio = this.monthsList[0];

        this.setFormaControle();
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }

    private setModelToForm() {
        var x: number, lenX: number, tipo: any;

        if (this.formObject.terceiro) {
            this.onHidePatrimonio();
        }

        if (this.formObject.dataCompra) {
            if (this.formObject.dataCompra.indexOf("/") === -1) {
                this.formObject.dataCompra = this._utilService.convertDateToString(this.formObject.dataCompra);
            }
        }

        if (this.formObject.dataTerminoGarantia) {
            if (this.formObject.dataTerminoGarantia.indexOf("/") === -1) {
                this.formObject.dataTerminoGarantia = this._utilService.convertDateToString(this.formObject.dataTerminoGarantia);
            }
        }

        if (this.formObject.dataVenda) {
            if (this.formObject.dataVenda.indexOf("/") === -1) {
                this.formObject.dataVenda = this._utilService.convertDateToString(this.formObject.dataVenda);
            }
        }

        if (this.formObject.cor) {
            this.corObject = this._utilService.cloneObject(this.formObject.cor);
            delete this.formObject['cor'];
            this.setCorAutoComplete();
        }

        if (this.formObject.situacao) {
            this.situacaoObject = this._utilService.cloneObject(this.formObject.situacao);
            delete this.formObject['situacao'];
            this.setSituacao();
        }

        if (this.formObject.modelo) {
            this.modeloObject = this._utilService.cloneObject(this.formObject.modelo);
            delete this.formObject['modelo'];
            this.modeloDisabled = false;

            tipo = '';
            if (this.modeloObject.tipoBem) {
                tipo = this.modeloObject.tipoBem.tipo + ' / ';
            }

            let text = this._autocompleteService.getTextSelect2(this.modeloObject, 'modelo');
            var selectObject:any = {text: tipo.concat(text), id: this.modeloObject.id};

            this._autocompleteService.createOptionOnSelect2(this.modeloSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.modeloSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'modelo', this.modeloObject);

            if (this.modeloObject.marca) {
                this.marcaObject = this._utilService.cloneObject(this.modeloObject.marca);
                delete this.modeloObject['marca'];

                let text = this._autocompleteService.getTextSelect2(this.marcaObject, 'marca');
                var selectObject:any = {text: text, id: this.marcaObject.id};

                this._autocompleteService.createOptionOnSelect2(this.marcaSelectId, selectObject);
                this._autocompleteService.setValueOnSelect2(selectObject.id, this.marcaSelectId);
                this._utilService.setSelectOnFormControl(this.form, 'marca', this.marcaObject);

                this.setMarcaOnModelo();
            }
        }

        if (this.formObject.orgao) {
            this.orgaoObject = this._utilService.cloneObject(this.formObject.orgao);
            delete this.formObject['orgao'];

            let text = this._autocompleteService.getTextSelect2(this.orgaoObject, 'razaoSocial');
            var selectObject:any = {text: text, id: this.orgaoObject.id};

            this._autocompleteService.createOptionOnSelect2(this.orgaoSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.orgaoSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'orgao', this.orgaoObject);
        }

        if (this.formObject.area) {
            this.areaObject = this._utilService.cloneObject(this.formObject.area);
            delete this.formObject['area'];

            let text = this._autocompleteService.getTextSelect2(this.areaObject, 'nome');
            var selectObject:any = {text: text, id: this.areaObject.id};

            this._autocompleteService.createOptionOnSelect2(this.areaSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.areaSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'area', this.areaObject);
        }

        if (this.formObject.divisao) {
            this.divisaoObject = this._utilService.cloneObject(this.formObject.divisao);
            delete this.formObject['divisao'];

            let text = this._autocompleteService.getTextSelect2(this.divisaoObject, 'divisao');
            var selectObject:any = {text: text, id: this.divisaoObject.id};

            this._autocompleteService.createOptionOnSelect2(this.divisaoSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.divisaoSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'divisao', this.divisaoObject);
        }

        if (this.formObject.setor) {
            this.setorObject = this._utilService.cloneObject(this.formObject.setor);
            delete this.formObject['setor'];

            let text = this._autocompleteService.getTextSelect2(this.setorObject, 'setor');
            var selectObject:any = {text: text, id: this.setorObject.id};

            this._autocompleteService.createOptionOnSelect2(this.setorSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.setorSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'setor', this.setorObject);
        }

        if (this.formObject.localidade) {
            this.localidadeObject = this._utilService.cloneObject(this.formObject.localidade);
            delete this.formObject['localidade'];

            let text = this._autocompleteService.getTextSelect2(this.localidadeObject, 'localidade');
            var selectObject:any = {text: text, id: this.localidadeObject.id};

            this._autocompleteService.createOptionOnSelect2(this.localidadeSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.localidadeSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'localidade', this.localidadeObject);
        }

        if (this.formObject.motoristaPrincipal) {
            this.motoristaObject = this._utilService.cloneObject(this.formObject.motoristaPrincipal);
            delete this.formObject['motoristaPrincipal'];

            if (this.motoristaObject.funcionario && this.motoristaObject.funcionario.pessoa) {
                var funcionario: any = this.motoristaObject.funcionario;
                var selectObject: any = {text: funcionario.pessoa.nome, id: this.motoristaObject.id};

                this._autocompleteService.createOptionOnSelect2(this.motoristaSelectId, selectObject);
                this._autocompleteService.setValueOnSelect2(selectObject.id, this.motoristaSelectId);
                this._utilService.setSelectOnFormControl(this.form, 'motorista', this.motoristaObject);
            }
        }

        if (this.formObject.gpsModelo) {
            this.modeloGpsObject = this._utilService.cloneObject(this.formObject.gpsModelo);
            delete this.formObject['gpsModelo'];

            var selectObject: any = {text: this.modeloGpsObject.modelo, id: this.modeloGpsObject.id};

            this._autocompleteService.createOptionOnSelect2(this.modeloGpsSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.modeloGpsSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'modeloGps', this.modeloGpsObject);
        }

        if (this.thisRoute === this.veiculosRoute) {
            for (x = 0, lenX = this.monthsList.length; x < lenX; x++) {
                if (this.formObject.mesIPVA && (this.formObject.mesIPVA === this.monthsList[x].Key || this.formObject.mesIPVA.Key === this.monthsList[x].Key)) {
                    this.formObject.mesIPVA = this.monthsList[x];
                }

                if (this.formObject.mesLicenciamento && (this.formObject.mesLicenciamento === this.monthsList[x].Key || this.formObject.mesLicenciamento.Key === this.monthsList[x].Key)) {
                    this.formObject.mesLicenciamento = this.monthsList[x];
                }

                if (this.formObject.mesSeguroObrigatorio && (this.formObject.mesSeguroObrigatorio === this.monthsList[x].Key || this.formObject.mesSeguroObrigatorio.Key === this.monthsList[x].Key)) {
                    this.formObject.mesSeguroObrigatorio = this.monthsList[x];
                }
            }

            if (!this.formObject.mesIPVA) {
                this.formObject.mesIPVA = this.monthsList[0];
            }

            if (!this.formObject.mesLicenciamento) {
                this.formObject.mesLicenciamento = this.monthsList[0];
            }

            if (!this.formObject.mesSeguroObrigatorio) {
                this.formObject.mesSeguroObrigatorio = this.monthsList[0];
            }
        }

        if (this.formObject.formaControle) {
            this.formaControleObject = this._utilService.cloneObject(this.formObject.formaControle);
            delete this.formObject['formaControle'];

            this.setFormaControle();
            if (this.formObject.odometroHorimetro) {
                this.formObject.odometroHorimetroValue = this._formaControleService.setOdometroHorimetroToForm(this.formObject.odometroHorimetro.odometroHorimetro);
                delete this.formObject['odometroHorimetro'];
            }
        }

        if (this.formObject.anoFabricacao) {
            this.formObject.anoFabricacao = this.formObject.anoFabricacao.toString();
        }

        if (this.formObject.anoModelo) {
            this.formObject.anoModelo = this.formObject.anoModelo.toString();
        }

        if (this.formObject.categoriaExigida) {
            this.categoriaCnhObject = this._utilService.cloneObject(this.formObject.categoriaExigida);
            delete this.formObject['categoriaExigida'];
            this.setCategoriaCnh();
        }
    }

    private goToList() {
        this._frotasService.clearBackStorage();
        this._frotaNavigationService.goToList(this.thisRoute);
    }

    private toLeaveHere() {
        this.goToList();
    }

    private setMarcaOnModelo() {
        this.setCategoriaOnModelo();
        var modeloQuery: string = JSON.stringify(this.modeloQuery);
        var marcaId: string = this.marcaObject.id;
        modeloQuery = modeloQuery.replace("REPLACEMARCAID", marcaId);
        this.modeloQuery = JSON.parse(modeloQuery);
        this.modeloDisabled = false;
    }

    private setCategoriaOnModelo() {
        var modeloQuery: string = JSON.stringify(modelosQueryComCategoriaMarca);
        var categoriaId: string = this.moduleId.toString();
        modeloQuery = modeloQuery.replace("REPLACECATEGORIAID", categoriaId);
        this.modeloQuery = JSON.parse(modeloQuery);
    }

    private setCorAutoComplete() {
        let text = this._autocompleteService.getTextSelect2(this.corObject, 'cor');
        var selectObject:any = {text: text, id: this.corObject.id};

        this._autocompleteService.createOptionOnSelect2(this.corSelectId, selectObject);
        this._autocompleteService.setValueOnSelect2(selectObject.id, this.corSelectId);
        this._utilService.setSelectOnFormControl(this.form, 'cor', this.corObject);
    }

    private setSituacao() {
        if (this.situacaoObject.id) {
            var element: any = document.getElementById("radioSituacao_"+this.situacaoObject.id);

            if (element) {
                element.checked = true;
            }
        }
    }

    private getCategoriasCnh() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.categoriasCnhList = Response;
                this.categoriasCnhList.unshift({id: null, categoria: '— Selecione —'});
                this.setCategoriaCnh();
            }
        }.bind(this));

        this._categoriaCnhApiService.onGetAllVeiculo(onDone);
    }

    private setCategoriaCnh() {
        var x: any, lenX: any,
            cnh: number = this.categoriaCnhObject.id;

        if (this.categoriasCnhList.length && !this.categoriaCnhObject.id) {
            cnh = this.categoriasCnhList[0].id;
        }

        for (x = 0, lenX = this.categoriasCnhList.length; x < lenX; x++) {
            if (this.categoriasCnhList[x].id === cnh) {
                this.categoriaCnhObject = this.categoriasCnhList[x];
                break;
            }
        }
    }

    private getFormasControle() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formasControleList = Response;
                this.setFormaControle();
            }
        }.bind(this));

        this._formaControleApiService.onGetAll(onDone);
    }

    private setFormaControle() {
        var x: any, lenX: any,
            sem: any = this._formaControleService.getFormaControleSem(),
            fc: number = this.formaControleObject.id;

        if (!this.formaControleObject.id) {
            fc = sem;
        }

        for (x = 0, lenX = this.formasControleList.length; x < lenX; x++) {
            if (this.formasControleList[x].id === fc) {
                this.formaControleObject = this.formasControleList[x];
                break;
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/frota-form/frota-form.component.ts
 **/